import { createAction } from 'redux-actions';
import {SET_METRIC, SET_METRICS_ALL } from '../constants/set';

export const setMetric = createAction(SET_METRIC, (m) => m);
export const setMetrics = createAction(SET_METRICS_ALL,(ms)=>ms);